/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { getAuthInstance } from '@/auth/authService'

export default {
  login ({ commit, state, dispatch }, payload) {

    // If user is already logged in notify and exit
    if (state.isUserLoggedIn()) {
      // Close animation if passed as payload
      if (payload.closeAnimation) payload.closeAnimation()

      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })

      return false
    }
  },

  // Github Login
  fetchAccessToken ({ commit, dispatch }, payload) {
    return new Promise(async (resolve) => {
      try {
        const token = await getAuthInstance().getTokenSilently();
        commit('SET_BEARER', token);
        resolve(token);
      } catch(e) {
        console.log(e);
        dispatch('logout');
      }
    })
  },
  logout ({ commit }, logoutUrl = process.env.VUE_APP_LANDING_PAGE_URL) {
    return new Promise(async (resolve) => {
      commit('SET_USER', null);
      commit('SET_BEARER', null);

      const authInstance = getAuthInstance();
      if (authInstance) {
        await authInstance.logout(logoutUrl);
      }

      resolve();
    })
  },
  setUser ({ commit }, user) {
    return new Promise(async (resolve) => {
      commit('SET_USER', user);

      resolve();
    })
  },
  setAccessDenied ({ commit }, accessDenied) {
    return new Promise(async (resolve) => {
      commit('SET_ACCESS_DENIED', accessDenied);
      resolve();
    })
  },
  setPasswordExpired ({ commit }, passwordExpired) {
    return new Promise(async (resolve) => {
      commit('SET_PASSWORD_EXPIRED', passwordExpired);
      resolve();
    })
  }
}
